<template>
  <div class="date-wrap">
    <el-calendar :model-value="new Date()" @select="handleDateSelect">
      <template slot="dateCell" slot-scope="{ date, data }">
        <div class="day" :class="{ 'is-selected': data.isSelected }">
          {{ date.getDate() }}
        </div>
        <!-- 只有有计划的日期才显示Popover按钮 -->
        <el-popover
          v-if="getPlanByDate(date)"
          placement="top"
          width="240"
          trigger="click"
          class="custom-popover">
          <ul class="plan-list">
            <!-- 列出计划详情 -->
            <li v-for="(item, index) in getPlanByDate(date).platList" :key="index">
              {{ item.clockMsg }}: <span :class="{'completed-plan': item.completeStatus, 'uncompleted-plan': !item.completeStatus}">
                {{ item.completeStatus ? '已完成' : '未完成' }}
              </span>
            </li>
          </ul>
          <el-button class="focus" :class="getPlanCompletionStatus(date)=='已完成'?'ok':''" slot="reference">
            <!-- 根据当前日期显示当日计划完成情况 -->
            {{ getPlanCompletionStatus(date) }}
          </el-button>
        </el-popover>
      </template>
    </el-calendar>
  </div>
</template>

<script>
export default {
  name: 'index',

  data() {
    return {
      plan: [] // 初始化为空数组，待接口数据填充
    };
  },
  created() {
    this.getClocklist();
  },
  methods: {
    // 根据日期获取当天的计划
    getPlanByDate(date) {
      const formattedDate = this.formatDate(date);
      return this.plan.find(planItem => planItem.date === formattedDate) || null;
    },

    // 判断计划是否全部完成
    getPlanCompletionStatus(date) {
      const plan = this.getPlanByDate(date);
      if (plan) {
        const allCompleted = plan.platList.every(item => item.clockStatus);
        return allCompleted ? '已完成' : '未完成';
      }
      return '';
    },

    // 格式化日期为YYYY-MM-DD
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    // 处理日期选择
    handleDateSelect(date) {
      console.log('Selected date:', date);
    },

    // 获取计划列表并处理数据
    async getClocklist() {
      const res = await this.$api.getClocklist();
      if (res.data.success) {
        // 格式化接口返回的数据并填充到 plan 中
        this.plan = res.data.data.map(item => ({
          date: item.date,
          platList: item.records.map(record => ({
            clockMsg: record.clockMsg,
            completeStatus: record.completeStatus
          }))
        }));
      } else {
        this.$message.error(res.data.errMsg || res.data.error || res.data.msg || res.data.message);
      }
    },
  }
};
</script>





<style lang="scss" scoped>
.date-wrap{
	padding: 2rem;
}
::v-deep .el-calendar__header .el-calendar__title {
  font-size: 1.4rem; /* 自定义字体大小 */
}
::v-deep .el-calendar__header .el-calendar__button-group button {
  font-size: 1.1rem; /* 调整按钮字体大小 */
  padding: 0.5rem 1rem; /* 调整按钮的内边距，影响按钮的整体大小 */
}
::v-deep .el-calendar-table .el-calendar-day{
	height: 6.7rem;
}
::v-deep .day{
	font-size: 1.2rem;
	padding: 0.25rem;
	display: flex;
	justify-content: center;
	flex-direction: column;
}
::v-deep .is-today{
	background-color: #F2F8FE;
}
::v-deep .focus{
	width: 8.6rem;
	height: 5.7rem;	
	margin-top: -2rem;
	background: none!important;
	padding: 0.5rem 1rem;
	border: 0;
	font-size: 1rem;
	display: flex;
	justify-content: flex-end;
	align-items: flex-end;
}
::v-deep .ok{
	color: rgb(100, 45, 113);
}
.custom-popover {
  font-size: 1rem; /* 调整字体大小 */
}
.plan-list li {
	margin: 0.5rem;
  font-size: 1rem; /* 调整字体大小 */
}
.completed-plan {
  color: #00D215; /* 已完成的计划项字体变为绿色 */
}
.uncompleted-plan {
  color: #FF0B0B; /* 未完成的计划项字体变为红色 */
}

.is-selected {
}
</style>